import React from "react";
import {
  Autocomplete,
  CircularProgress,
  FormControl,
  TextField,
} from "@mui/material";
import { fieldToTextField } from "formik-mui";

export const FormikAutocomplete = ({
  label,
  margin,
  textFieldProps,
  loading,
  ...props
}) => {
  const {
    form: { setTouched, setFieldValue },
  } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  return (
    <FormControl
      fullWidth
      focused
      margin={margin}
      sx={{
        label: {
          backgroundColor: "white",
        },
      }}
      variant="outlined"
    >
      <Autocomplete
        id={`autocomplete-${name}`}
        {...field}
        onChange={(_, value) => {
          setFieldValue(name, value);
        }}
        onBlur={() => setTouched({ [name]: true })}
        loading={loading}
        renderInput={(props) => (
          <TextField
            label={label}
            {...props}
            {...textFieldProps}
            helperText={helperText}
            error={error}
            InputProps={{
              ...(props.InputProps ?? {}),
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {props.InputProps?.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        {...props}
      />
    </FormControl>
  );
};
